export default __webpack_public_path__ + "static/media/empty-online-lesson.db01455a.png";